import React from 'react';
import PropTypes from "prop-types";

/*
    GeneralTable
    @param {String} settingsColumns - The columns to be applied to the table.
    @param {String} gap - The gap to be applied to the table.
    @param {String} marginTop - The marginTop to be applied to the table.
    @param {Boolean} noMargins - Whether or not the table should have margins.
    @param {Object} style - The style to be applied to the table.
    @param {Object} children - The children to be wrapped.
    @param {Function} onClick - The function to be called when the table is clicked.
    @param {Boolean} asDataTableAdvanced - turns all columns into minmax(40px,auto)
    @param {Boolean} useColumnSpec - Whether or not the table should use the column spec.
    @param {Boolean} asDataTable - Shows table headers nicely + rounded
 */
export default function GeneralTable({settingsColumns, gap, marginTop, noMargins, style, children, onClick, asDataTableAdvanced, useColumnSpec, asDataTable, ref}) {

    let settingColumns = settingsColumns || '150px 2fr 2fr 1fr 1fr 150px';
    // settingColumns.replace(/1fr/g, 'minmax(90,auto)');
    // settingColumns.replace(/50px/g, 'minmax(90,auto)');
    // settingColumns.replace(/100px/g, 'minmax(90,auto)');

    let l = settingColumns.split(' ');
    for(let x in l) {
        if(!(l[x].toLowerCase().includes('px') || asDataTableAdvanced)) {
            l[x] ='minmax(40px,auto)';
        }
    }

    const templateGrid = {
        display: 'grid',
        gridGap: gap ? gap : 0,
        gridWrap: 'wrap',
        gridTemplateColumns: useColumnSpec ? settingsColumns : l.join(' '),
        width:'100%',
        marginTop: marginTop ? marginTop : 0,
        margin: noMargins && marginTop ? 0 : null,
        padding: noMargins ? 0 : null,
        overflow: 'auto hidden',
        boxSizing: 'border-box',
        ...style,
    };

    const asPaper = {
        ...templateGrid,
        // borderRadius: 10,
        // marginLeft:2,
        // boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)',
        // ...style,
        // margin: noMargins && marginTop ? 0 : null,
        // padding: 0,
        // background:'azure !important',
        // overflow: 'auto hidden',
        // boxSizing: 'border-box',
    }

    const asDataTableDef = {
        borderRadius: 10,
        border:'1px solid #eaeaea',
        marginLeft:2,
        // boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)',
        margin: (noMargins === true && marginTop === true) ? 0 : null,
        padding: 0,
        gap:10,
        background:'white',
        display:'grid',
        overflow: 'auto hidden',
        boxSizing: 'border-box',
    }


    if(asDataTable) return (
        <div style={asDataTableDef} ref={ref}>
            <div style={(asPaper) ? asPaper : templateGrid} onClick={onClick || null}>
                {children}
            </div>
        </div>
    )

    return (
        <div style={(asPaper) ? asPaper : templateGrid} onClick={onClick || null} ref={ref}>
            {children}
        </div>
    )
}

GeneralTable.propTypes = {
    settingsColumns: PropTypes.string
};
